import Vue from 'vue';
import { Component } from 'vue-property-decorator';

// You can declare a mixin as the same style as components.
@Component
export default class MyMixin extends Vue {
  mixinValue = 'Hello from mixin';
  created() {
    console.log(this.mixinValue);
  }
}
